var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget_badget",attrs:{"disabled":_vm.is_loading},on:{"click":_vm.onClick}},[_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }